import { render, staticRenderFns } from "./MessageSignature.vue?vue&type=template&id=2705bd36&"
import script from "./MessageSignature.vue?vue&type=script&lang=js&"
export * from "./MessageSignature.vue?vue&type=script&lang=js&"
import style0 from "./MessageSignature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports